import PatientResults from './PatientResults';

export default PatientResults;
